import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Featus = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M28 11C28 7.14 24.86 4 21 4C17.14 4 14 7.14 14 11C14 12.08 14.248 13.103 14.687 14.017C14.41 14.046 14.144 14.112 13.895 14.211C13.548 12.938 12.381 12 11 12H9.829C9.416 10.836 8.304 10 7 10C5.346 10 4 11.346 4 13V15C4 16.654 5.346 18 7 18H7.401C6.871 19.244 6.25 21.106 6.25 23C6.25 25.757 8.493 28 11.25 28C22.125 28 26 23.351 26 19C26 18.088 25.753 17.233 25.325 16.497C26.952 15.214 28 13.228 28 11ZM21.309 23.675C19.091 25.196 15.612 26 11.25 26C9.596 26 8.25 24.654 8.25 23C8.25 20.316 9.848 17.531 9.864 17.504C10.044 17.195 10.046 16.812 9.867 16.502C9.688 16.192 9.358 16 9 16H7C6.449 16 6 15.551 6 15V13C6 12.449 6.449 12 7 12C7.551 12 8 12.449 8 13C8 13.552 8.448 14 9 14H11C11.551 14 12 14.449 12 15V17C12 18.647 13.335 19.988 14.98 20C14.634 20.597 13.989 21 13.25 21C12.698 21 12.25 21.448 12.25 22C12.25 22.552 12.698 23 13.25 23C15.111 23 16.678 21.723 17.123 20H19C19.552 20 20 19.552 20 19C20 18.448 19.552 18 19 18H15C14.449 18 14 17.551 14 17C14 16.449 14.449 16 15 16H21C22.654 16 24 17.346 24 19C24 20.852 23.07 22.468 21.309 23.675V23.675ZM23.995 14.999C23.16 14.372 22.122 14 21 14H17.003C16.374 13.164 16 12.125 16 11C16 8.243 18.243 6 21 6C23.757 6 26 8.243 26 11C26 12.634 25.211 14.086 23.995 14.999Z" />
	</svg>
);

export default Featus;
